import { Block, Typography } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { PropertyGridForm } from '../types.ts';
import { readOnlyFieldTypographyProps } from './consts.ts';
import { PropertyGridFieldProps } from './types.ts';
import { EditableDateField } from './EditableDateField.tsx';

export const ContractDateField = ({
  columnIndex,
  field,
  control,
  getValues,
  setValue,
  colSpan,
}: PropertyGridFieldProps) => {
  const statusFieldName: FieldPath<PropertyGridForm> = `columns.${columnIndex}.propertyData.editableData.transaction.status`;
  const status = useWatch({ control, name: statusFieldName }) as string | undefined;

  if (status && !['SettledSale', 'Contract'].includes(status)) {
    return <Block gridColumn={`span ${colSpan}`}><Typography {...readOnlyFieldTypographyProps}>-</Typography></Block>;
  }

  return <EditableDateField
    columnIndex={columnIndex}
    field={field}
    control={control}
    getValues={getValues}
    setValue={setValue}
    colSpan={colSpan}
  />
};
